// import { get } from "lodash";

export default {
  getAdminDashboard: (state) => state.adminDashboard,
};
